<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <add-button @click="table_addItem">{{$I18n("add_company")}}</add-button>
          <!-- 卡片主体(表格) -->
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('company_id')">{{ item.comp_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('company_name')">
                {{ item.comp_name }}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('comp_short_name')">
                {{ item.comp_short_name }}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('auth_state')">
                {{ item.authState }}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('leading_name')">
                {{ item.comp_person }}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button
                  @click.stop="table_chargeItem(item)"
                  class="md-just-icon md-round left-icon md-info"
                  ><md-icon>money</md-icon></md-button
                >
                <md-button
                  @click.stop="table_editItem(item)"
                  class="md-just-icon md-round md-info"
                  ><md-icon>edit</md-icon></md-button
                >
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">
              {{$I18n("none_data")}}
            </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :right = "openModalType!=='delete'"
      :large = "openModalType==='import'"
      @submit= "modal_submit"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", modalData.Form.comp_name)}}</div>
        <!-- 给他人充值(用自己的余额) -->
        <div v-else-if="openModalType==='charge'">
          <common-form-item 
            v-for="item in form_modalChargeData" 
            v-model="chargeModalData.Form[item.keys]" 
            :error="chargeModalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
        <!-- 修改/添加弹窗 -->
        <div class="md-layout" v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <md-field v-if="item.keys === 'zone'" :class="{'md-error':modalData.Error.zone}">
              <md-select v-model="zone">
                <md-option v-for="item in countryArray" :key="item.code" :value="item.code">{{
                  $router.history.current.query.lang === "zh" ?item.cn_name :item.name
                }}</md-option>
              </md-select>
              <md-icon v-if="modalData.Error.zone">clear</md-icon>
              <div @click="() => $refs.zone.open()" style="position:absolute; top: 0; bottom: 0;left: 0; right: 0;z-index: 1;cursor: pointer;"></div>
            </md-field>
          </common-form-item>
          <common-form-item 
            v-for="item in form_showData" 
            v-model="showData.Form[item.keys]" 
            :hide="openModalType != 'edit'"
            :key="item.keys" v-bind="item"
          >
            <div v-if="item.type == 'image'">
              <img :src="showData.Form.license_url" style="max-width: 100%"/>
            </div>
          </common-form-item>
        </div>
      </template>
    </simple-modal>
    <zone-select-modal ref="zone" @select="changeZone" :useAll="false"/>
  </div>
</template>
<script>
import { FormClass, timestampToString } from "@/common/tools.js";
import json from 'v-distpicker/src/districts.js'
import ZoneSelectModal from "@/components/Common/ZoneSelectModal";
import {countryArray, continentArray} from "@/common/continent.js";

export default {
  props: ["userinfo_sys"],
  components: {
    ZoneSelectModal,
  },
  data() {
    let no_role = this.UserInfo.role_id >= 10000
    return {
      zone:"",
      countryArray, 
      continentArray,
      areaData: {
        ...json,
        "":{},
      },
      // 表格相关
      ...({
        formData:{
          type : 0,
        },
        searchData : {
          type : 0,
        },
        icon  : "computer",
        title : this.$I18n("company"),
        tableInitData : [], // 表格数据
        // 分页相关
        pageSize : 10,
        currentPage : 1,
        total : 0,
        // 弹窗相关
        openModal: false,  // 是否打开弹窗
        openModalType : "upload", // 弹窗类型
        modalTitle : "",  // 弹窗标题
      }),
      // 弹窗表单相关
      ...({

        chargeModalData : new FormClass({
          your_money      : {},
          company_balance :"",
          money_type      : "USD",
          money           : 0,
          // money_obj:{},
        },{
          money : value => {
            return isNaN(value) || parseFloat(value) <= 0 
          },
          your_money : (value, formValue) => {
            console.log(formValue.your_money, formValue.money_type, formValue.money)
            return no_role && parseFloat(formValue.your_money[formValue.money_type]) < parseFloat(formValue.money)
          }
        }),

        modalData : new FormClass({
          comp_id:"",
          comp_name : "",
          comp_short_name : "",
          comp_addr : "",
          comp_person : "",
          comp_phone : "",
          // sys : this.userinfo_sys,
          comp_key:"",
          dk_limit:1,
          comp_parent_id: "0",
          zone            : "",
          dk   : "",
        },{
          zone : "required",
          comp_name   : "required",
          // sys         : "required",
          comp_addr   : "required",
          comp_person : "required",
        }),
        showData: new FormClass({})
      }),
      //全部公司
      fullCompany:[],
    };
  },
  mounted : function() {
    //获取菜单
    this.$api.getCompanyList({
      page_size : 99999,
      page_index: 1,
    })
      .then(this.$Then(res => {
        this.fullCompany = res.data.map(i => {
          return {
            id  : i.comp_id,
            name: i.comp_name,
          }
        });
      }))
      .catch(this.$Catch(this.$I18n("get_error"), () => {
        this.fullCompany = [];
      }))
    this.api_getPageData();
  },
  watch: {
    currentPage() {
      this.api_getPageData();
    },
  },
  computed: {
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return [...this.tableInitData]
          // .splice((this.currentPage-1) * this.pageSize, this.pageSize)
          .map(item => {
            let type_name = "";
            switch(item.type){
              case 1:
                type_name = this.$I18n("quectel");
                break;
              default:
                type_name = this.$I18n("unknow");
                break;
            }
            return {
              ... item,
              authState: this.$I18n(this.$Param.authState.getName(item.auth_state)),
              type_name,
              comp_phone: item.phone,
              comp_parent_id: item.comp_parent_id?item.comp_parent_id :"0",
            }
          })
      }
    },
    form_modalChargeData(){
      return [
        {
          label   : this.$I18n("your_money"),
          keys    : "your",
          type    : "input",
          required: true,
          disabled: true,
        },{
          label   : this.$I18n("balance_company"),
          keys    : "company_balance",
          type    : "input",
          hide    : this.UserInfo.role_id >= 10000,
          required: true,
          disabled: true,
        },{
          label   : this.$I18n("currency_type"),
          keys    : "money_type",
          type    : "select",
          options : [
            {id: 'CNY', name : this.$I18n("curr_name_CNY")},
            {id: 'USD', name : this.$I18n("curr_name_USD")},
            {id: 'INR', name : this.$I18n("curr_name_INR")},
            {id: 'IDR', name : this.$I18n("curr_name_IDR")},
          ].filter(i => parseFloat(this.chargeModalData.Form.your_money[i.id]) > 0),
          placeholder: this.$I18n('pls_input_role_id'),
        },{
          label   : this.$I18n("recharge_num"),
          keys    : "money",
          type    : "input",
          required: true,
        },
      ]
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("company_name"),
          keys    : "comp_name",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("comp_short_name"),
          keys    : "comp_short_name",
          type    : "input",
          class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("belong_comp"),
          keys    : "comp_parent_id",
          type    : "select",
          class   : "md-layout-item md-size-50",
          options : [
            {id: "0", name: this.$I18n("none")},
            ...this.fullCompany,
          ],
          hide    : this.UserInfo.role_id >= 10000,
        },{
          label   : this.$I18n("dk_limit"),
          keys    : "dk_limit",
          type    : "select",
          options : [
            {id: "1", name: this.$I18n("open")},
            {id: "2", name: this.$I18n("close")},
          ],
          class   : "md-layout-item md-size-50",
          hide    : this.UserInfo.role_id >= 10002,
        },{
          label   : this.$I18n("comp_key"),
          keys    : "comp_key",
          type    : "input",
          class   : "md-layout-item md-size-50 md-xsmall-size-100",
          placeholder   : this.$I18n("deivce_code_placehoder"),
          disabled: !!this.modalData.Form.comp_id,
        },{
          label   : this.$I18n("deivce_code"),
          keys    : "dk",
          type    : "input",
          placeholder   : this.$I18n("deivce_code_placehoder"),
          class   : "md-layout-item md-size-50 md-xsmall-size-100",
        },{
          label   : this.$I18n("zone"),
          keys    : "zone",
          required: true,
          class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("company_address"),
          keys    : "comp_addr",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("leading_name"),
          keys    : "comp_person",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("phone"),
          keys    : "comp_phone",
          class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("auth_state"),
          keys    : "auth_state",
          required: true,
          hide    : this.openModalType === "add",
          disabled: this.UserInfo.role_id >= 10000,
          class   : "md-layout-item md-size-50",
          type    : "select",
          options : this.$Param.authState.map(i => {
            return {
              id: i.id,
              name: this.$I18n(i.name),
            }
          }),
        },{
          label   : this.$I18n("auth_desc"),
          keys    : "auth_desc",
          required: true,
          hide    : this.modalData.Form.auth_state != 4,
          class   : "md-layout-item md-size-50",
          type    : "input",
        }
      ]
    },
    form_showData(){
      return [
        {
          label   : this.$I18n("company_type"),
          keys    : "comp_type",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-50",
        },
        {
          label   : this.$I18n("uni_soc_code"),
          keys    : "comp_license_no",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-50",
        },
        {
          label   : this.$I18n("bus_lic_add"),
          keys    : "comp_license_addr",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-50",
        },
        {
          label   : this.$I18n("bus_lic_start_date"),
          keys    : "_comp_license_start",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-50",
        },
        {
          label   : this.$I18n("bus_lic_end_date"),
          keys    : "_comp_license_end",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-50",
        },
        {
          label   : this.$I18n("bus_lic_doc"),
          keys    : "license_url",
          type    : "image",
          disabled: true,
          class   : "md-layout-item md-size-100",
        },
      ]
    }
  },
  methods: {
    changeZone(zone){
      this.modalData.Form.zone = zone;
      this.zone = zone;
    },
    table_chargeItem(item){
      this.modalTitle = this.$I18n("recharge_num");

      this.$api.getBalance({})
        .then(res => {
          if(this.UserInfo.role_id >= 10000){
            return res
          }
          return this.$api.getBalance({
            comp_id : item.comp_id,
          })
            .then(this.$Then(compRes => {
              let str = "";
              const json = JSON.parse(compRes.data?.money ?? '{}' )
              for(var key in json){
                str = str + (str ?", " :"") + this.$I18n("curr_" + key) + ": " + json[key];
              }
              return {
                ...res,
                company_balance: str,
                company_obj: json,
              }
            }))
            .catch(this.$Catch(this.$I18n("get_error")))
        })
        .then(this.$Then(res => {
          let str = "";
          const json = JSON.parse(res.data?.money ?? '{}' )
          for(var key in json){
            str = str + (str ?", " :"") + this.$I18n("curr_" + key) + ": " + json[key];
          }
          this.chargeModalData.Update({
            ...item,
            your_money: json,
            your: str,
            money_type: Object.keys(json)[0] ?Object.keys(json)[0] :'',
            money:0,
            company_balance: res.company_balance ?res.company_balance :"",
            company_obj: res.company_obj ?res.company_obj :{},
          });
          this.openModalType = "charge";
          this.openModal = true;
          this.$refs.modal.open();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    form_changeSearchData(){
      this.searchData = {...this.formData}
      this.currentPage = 1;
      this.api_getPageData();
    },
    table_addItem(){
      this.modalTitle = this.$I18n("add");
      this.modalData.Reset();
      this.zone = '';
      this.openModalType = "add";
      this.openModal = true;
      this.$refs.modal.open();
    },
    table_editItem(item){
      this.modalTitle = this.$I18n("edit");
      this.modalData.Update(item);
      this.zone = item.zone;

      this.showData.Update({
        ...item,
        _comp_license_start: item.comp_license_start ?timestampToString(new Date(item.comp_license_start).getTime()).split(" ")[0] :"",
        _comp_license_end  : item.comp_license_end ?timestampToString(new Date(item.comp_license_end).getTime()).split(" ")[0] :"",
      })

      this.openModalType = "edit";
      setTimeout(()=> {
        this.$refs.modal.open();
        this.openModal = true;
      },0);
    },
    table_deleteItem(item){
      this.modalTitle = this.$I18n("delete");
      this.modalData.Update(item);
      this.openModalType = "delete";
      this.$refs.modal.open();
      this.openModal = true;
    },
    // 获取页面信息
    api_getPageData(){
      //获取菜单
      this.$api.getCompanyList({
        only_sub: 1,
        page_size : this.pageSize,
        page_index   : this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.count // - 1;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 提交表单
    modal_submit () {
      if(this.openModalType != "charge"){
        if (this.modalData.Check()){
          this.$errorMsg(this.$I18n("pls_input_content"));
          return;
        }
      }
      // let opcode = 1;
      if(this.openModalType === "add"){
        this.$api.addCompany({
          ...this.modalData.Form,
          phone : this.modalData.Form.comp_phone,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.$refs.modal.close();
            this.api_getPageData();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if (this.openModalType === "edit"){
        this.$api.editCompany({
          ...this.modalData.Form,
          phone : this.modalData.Form.comp_phone,
          auth_desc: this.modalData.Form.auth_state == 4 ?this.modalData.Form.auth_desc :"",
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.$refs.modal.close();
            this.api_getPageData();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if (this.openModalType === "delete"){
        this.$api.delCompany({
          ...this.modalData.Form,
          phone : this.modalData.Form.comp_phone,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.$refs.modal.close();
            this.api_getPageData();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if (this.openModalType === "charge"){
        if(this.chargeModalData.Check()){
          if(this.chargeModalData.Error.money){
            this.$errorMsg(this.$I18n("pls_input_post_num"))
            return 
          } else {
            this.$errorMsg(this.$I18n("no_enouth_money"))
            return 
          }
        }
        this.$api.setBalance({
          ...this.chargeModalData.Form,
          currency_code: this.chargeModalData.Form.money_type,
          amount: this.chargeModalData.Form.money,
          type: 1,
          money_type: 1,
          to_comp_id : this.chargeModalData.Form.comp_id,
        })
          .then(this.$Then(() => {
            window.__regetBalace();
            this.$successMsg(this.$I18n("succ_num"));
            this.$refs.modal.close();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .md-layout-item.md-size-5{
    padding: 0 14px;
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>